import React from "react";
import PropTypes from "prop-types";
import { convertStringToElements } from "@vds/html-parsers";
import styled from "styled-components";

import Modal from "common-components/Modal/Modal";
import Button from "common-components/Buttons";
import { ENDPOINTS } from "utils/endpoints";

const DownloadModal = ({
  fileSize,
  uniqueTxnId,
  mtn,
  checkForCSRFTokenInfo,
  modalContent,
  fileFormat,
  showModal,
  toggleModal,
  ...props
}) => {
  const fileFormatObject = modalContent.genericList[0].list[0];

  return (
    <Modal visibleModal={showModal} closeModal={toggleModal} contentLabel="download file">
      <h2 style={{ marginBottom: "24px" }}>{modalContent.section_title}</h2>
      <Div>{convertStringToElements(modalContent.section_description)}</Div>
      <div style={{ marginTop: "24px" }}>
        <P>
          <strong>{fileFormatObject.jsonKey}</strong> .{fileFormat.toUpperCase()}{" "}
          {fileFormat.toUpperCase() === "XLSX" ? fileFormatObject.excelValue : fileFormatObject.jsonValue}
        </P>
        <P style={{ marginBottom: "34px" }}>
          <strong>{modalContent.genericList[0].list[1].jsonKey}</strong> {fileSize}
        </P>
        <form
          action={ENDPOINTS.AGENT_DOWNLOAD_FILE}
          method="post"
          encType="application/x-www-form-urlencoded"
        >
          <input hidden type="text" name="uniqueTxnId" readOnly value={uniqueTxnId} />
          <input hidden type="text" name="mtn" readOnly value={mtn} />
          <input hidden type="text" name="csrfTokenInfo" readOnly value={checkForCSRFTokenInfo()} />
          <Button type="submit" background={modalContent.buttons[0].type}>
            {modalContent.buttons[0].text}
          </Button>
        </form>
      </div>
    </Modal>
  );
};

export { DownloadModal };

DownloadModal.propTypes = {
  fileSize: PropTypes.string.isRequired,
  uniqueTxnId: PropTypes.string.isRequired,
  checkForCSRFTokenInfo: PropTypes.func.isRequired,
  modalContent: PropTypes.object.isRequired
};

const P = styled.p`
  margin-bottom: 10px;
`;

const Div = styled.div`
  max-width: 466px;

  p {
    margin: 15px 0;
  }
`;
